/**
 * highlightsAndNotes
 * takes VS returned highlights and normalizes for input to redux
 * if highlight contains notes normalize them
 *
 * @param {Array} An array of VS returned highlights
 * @return {Array} An array of normalized highlight & note objects
 */
function* highlightsAndNotes(vsHighlights) {
  let userHighlights = [];
  let userNotes = [];

  for (const vsHighlight of vsHighlights) {
    const userHighlight = {
      id: vsHighlight.syncId,
      markerId: vsHighlight.markerId,
      selectedText: vsHighlight.selectedText,
      noteText: vsHighlight.hasNote ? vsHighlight.noteText : '',
      cfi: vsHighlight.cfi,
      color: vsHighlight.vstColor,
      lastModifiedAt: vsHighlight.lastModifiedAt
    };

    if (vsHighlight.hasNote) {
      const userNote = {
        id: vsHighlight.syncId,
        text: vsHighlight.noteText,
        cfi: vsHighlight.cfi,
        lastModifiedAt: vsHighlight.lastModifiedAt
      }

      userNotes.push(userNote);
    }

    userHighlights.push(userHighlight);
  }

  return [ userHighlights, userNotes ];
}


export default highlightsAndNotes;
